import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { Box, Container, Grid, Typography, Link, Chip, useTheme, useMediaQuery, } from '@mui/material';
import { brandColors } from '../theme/colors';
export const Footer = ({ logo, navigationColumns = [], contactInfo, copyrightText = `© Copyright Horwath HTL ${new Date().getFullYear()}`, privacyPolicyLink, apiUrl, }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [apiStatus, setApiStatus] = useState('loading');
    useEffect(() => {
        const checkApiStatus = async () => {
            if (!apiUrl) {
                setApiStatus('offline');
                return;
            }
            try {
                const response = await fetch(`${apiUrl}/api/status`, {
                    method: 'GET',
                    signal: AbortSignal.timeout(5000), // 5 second timeout
                });
                if (response.ok) {
                    setApiStatus('online');
                }
                else {
                    setApiStatus('offline');
                }
            }
            catch (_a) {
                setApiStatus('offline');
            }
        };
        checkApiStatus();
        // Check status every 30 seconds
        const interval = setInterval(checkApiStatus, 30000);
        return () => clearInterval(interval);
    }, [apiUrl]);
    return (_jsx(Box, { component: "footer", sx: {
            backgroundColor: brandColors.indigo,
            color: brandColors.white,
            py: { xs: 4, md: 6 },
            mt: 'auto',
        }, children: _jsxs(Container, { maxWidth: "lg", children: [_jsxs(Grid, { container: true, spacing: 4, children: [_jsxs(Grid, { item: true, xs: 12, md: 4, children: [logo && (_jsx(Box, { sx: { mb: 3 }, children: logo })), contactInfo && (_jsxs(Box, { children: [contactInfo.title && (_jsx(Typography, { variant: "h6", gutterBottom: true, children: contactInfo.title })), contactInfo.address && contactInfo.address.map((line, index) => (_jsx(Typography, { variant: "body2", sx: { mb: 0.5 }, children: line }, index))), contactInfo.phone && (_jsxs(Typography, { variant: "body2", sx: { mb: 0.5 }, children: ["Tel: ", _jsx(Link, { href: `tel:${contactInfo.phone}`, color: "inherit", children: contactInfo.phone })] })), contactInfo.email && (_jsxs(Typography, { variant: "body2", children: ["Email: ", _jsx(Link, { href: `mailto:${contactInfo.email}`, color: "inherit", children: contactInfo.email })] }))] }))] }), navigationColumns.map((column, index) => (_jsxs(Grid, { item: true, xs: 6, sm: 4, md: 2, children: [_jsx(Typography, { variant: "h6", gutterBottom: true, sx: { fontSize: '1rem', fontWeight: 'bold' }, children: column.title }), _jsx(Box, { children: column.links.map((link, linkIndex) => (_jsx(Typography, { variant: "body2", sx: { mb: 1 }, children: _jsx(Link, { href: link.href, onClick: link.onClick, color: "inherit", underline: "hover", sx: {
                                                '&:hover': {
                                                    color: brandColors.gold,
                                                },
                                            }, children: link.label }) }, linkIndex))) })] }, index)))] }), _jsxs(Box, { sx: {
                        mt: 4,
                        pt: 3,
                        borderTop: `1px solid ${brandColors.grayMedium}33`,
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: 2,
                    }, children: [_jsx(Typography, { variant: "body2", children: copyrightText }), _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 2 }, children: [privacyPolicyLink && (_jsx(Link, { href: privacyPolicyLink, color: "inherit", underline: "hover", sx: {
                                        '&:hover': {
                                            color: brandColors.gold,
                                        },
                                    }, children: "Privacy Policy" })), apiUrl && (_jsx(Chip, { size: "small", label: apiStatus === 'loading' ? '...' : apiStatus === 'online' ? 'API ●' : 'API ✕', color: apiStatus === 'online' ? 'success' : apiStatus === 'offline' ? 'error' : 'default', variant: "outlined", sx: {
                                        height: '24px',
                                        fontSize: '12px',
                                        fontWeight: 'bold',
                                        borderColor: apiStatus === 'online' ? brandColors.success : apiStatus === 'offline' ? brandColors.error : brandColors.grayMedium,
                                        color: brandColors.white,
                                        '& .MuiChip-label': {
                                            px: 1,
                                        },
                                    }, title: `API Status: ${apiStatus}` }))] })] })] }) }));
};
//# sourceMappingURL=Footer.js.map